export enum RegistrationStep {
  USER_INFO = 0,
  ACCESS = 1,
  PASSWORD = 2,
  CONFIRMATION_CODE = 3,
}

export const STEP_LABELS = {
  [RegistrationStep.USER_INFO]: 'Details',
  [RegistrationStep.CONFIRMATION_CODE]: 'Confirmation',
  [RegistrationStep.ACCESS]: 'Access',
  [RegistrationStep.PASSWORD]: 'Password',
} as const;
